export var RequestHeaders = {
  headers: {
    Accept: 'application/json'
  }
};